import { Directive, TemplateRef, inject, input } from '@angular/core';
import { AiRunnerSlotContext } from './ai-runner.model';

/** Pontos do modal que o host pode preencher com `<ng-template aiRunnerSlot="...">`. */
export type AiRunnerSlotName =
  /** Acima de tudo no corpo do modal (aviso, contexto do uso). Adiciona; não substitui. */
  | 'header'
  /** Campos extras ao fim do formulário de entrada. Adiciona; não substitui. */
  | 'form'
  /** Substitui a barra/spinner de andamento. */
  | 'loading'
  /** Substitui a linha do tempo de etapas. */
  | 'steps'
  /** Substitui o alerta de erro. */
  | 'error'
  /** Botões extras no rodapé, antes de "Fechar". Adiciona; não substitui. */
  | 'footer';

/**
 * `<ng-template aiRunnerSlot="loading" let-ctx>…</ng-template>` dentro de `<ai-runner-dialog>`.
 * O contexto (`$implicit`) é um `AiRunnerSlotContext`. Slot ausente = apresentação padrão.
 */
@Directive({ selector: 'ng-template[aiRunnerSlot]', standalone: true })
export class AiRunnerSlotDirective {
  readonly name = input.required<AiRunnerSlotName>({ alias: 'aiRunnerSlot' });
  readonly template = inject<TemplateRef<{ $implicit: AiRunnerSlotContext }>>(TemplateRef);

  static ngTemplateContextGuard(
    _dir: AiRunnerSlotDirective,
    ctx: unknown
  ): ctx is { $implicit: AiRunnerSlotContext } {
    return true;
  }
}
